import searchIcon from "@tabler/icons/outline/search.svg";
import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import { IconButton } from "@/components/ui";

import type { Group } from "@/schemas";

const messages = defineMessages({
  search: { id: "group.search", defaultMessage: "Search" },
});

interface GroupSearchButtonProps {
  group: Group;
}

const GroupSearchButton = ({ group }: GroupSearchButtonProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <IconButton
      src={searchIcon}
      onClick={() => navigate(`/group/${group.slug}/search`)}
      title={intl.formatMessage(messages.search)}
      variant="outline"
      className="px-2.5"
      iconClassName="h-5 w-5"
    />
  );
};

export default GroupSearchButton;
